<template>
  <Select v-model="internalValue">
    <SelectTrigger
      :class="[`bg-white`, size === 'sm' ? 'h-8' : size === 'lg' ? 'h-10 md:h-12' : 'h-9']"
      :style="{ width: width || '180px' }"
    >
      <SelectValue :placeholder="placeholder ?? '선택해 주세요'" />
    </SelectTrigger>

    <SelectContent class="border-none bg-white">
      <SelectGroup>
        <SelectItem v-for="option in options" :key="option.value" :value="option.value">
          {{ option.label }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps<{
  modelValue?: string;
  options: { label: string; value: string }[];
  width?: string;
  mobileWidth?: string;
  placeholder?: string;
  size?: "sm" | "default" | "lg";
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const internalValue = ref(props.modelValue ?? "");

watch(
  () => props.modelValue,
  (val) => (internalValue.value = val ?? "")
);

watch(internalValue, (val) => emit("update:modelValue", val));
</script>
